// Zone.js configuration flags — must be set before zone.js loads.
// Disabling patches for APIs the app does not use through Angular zone
// reduces zone.js startup time without affecting functionality.

// Not used via Angular zone in this app:
(window as any).__Zone_disable_IntersectionObserver = true;
(window as any).__Zone_disable_MediaQuery = true;
(window as any).__Zone_disable_customElements = true;
// on_property patch (161ms desktop) — app uses Angular event bindings, not native onclick= attributes
(window as any).__Zone_disable_on_property = true;
// Browser Notification API not used (app has its own Notification model)
(window as any).__Zone_disable_notification = true;
// Geolocation not used anywhere in the app
(window as any).__Zone_disable_geolocation = true;
